var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM15.923 17.698C15.682 18.266 15.201 18.509 14.64 18.347C14.159 18.185 13.597 17.779 13.036 17.131C12.475 17.212 11.913 17.374 11.352 17.536C10.71 18.671 10.069 19.644 9.427 19.887C9.266 19.968 9.106 20 8.945 20C8.624 20 8.384 19.887 8.223 19.644C8.063 19.401 7.742 18.914 8.383 18.185C8.784 17.698 9.746 17.212 10.789 16.888C11.11 16.239 11.35 15.591 11.591 14.861C11.03 13.807 10.709 12.672 10.789 12.023C10.87 11.373 11.282 11 11.832 11C12.382 11 12.714 11.373 12.875 11.941C13.035 12.59 12.875 13.644 12.474 14.86C12.715 15.347 13.035 15.833 13.356 16.319C14.318 16.238 15.12 16.238 15.602 16.562C16.003 16.806 16.083 17.211 15.923 17.698ZM13 9V3.5L18.5 9H13Z",
    fill: "#F71F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon_pdf.a611ddd42270192698c59faec3525dfb.svg";
export { ForwardRef as ReactComponent };